// extracted by mini-css-extract-plugin
export default {"monalisa-wrapper":"_2VgGc","monalisaWrapper":"_2VgGc","monalisa-icon":"_2qyfU","monalisaIcon":"_2qyfU"};